module.exports = __webpack_public_path__ + "static/media/reachcustomermain4.6b0d1ff9.png";